import { render, staticRenderFns } from "./LyoutPri.vue?vue&type=template&id=5c7bfbe0&"
import script from "./LyoutPri.vue?vue&type=script&lang=js&"
export * from "./LyoutPri.vue?vue&type=script&lang=js&"
import style0 from "./LyoutPri.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports